import React, { ReactNode } from 'react';
import styles from './SectionTitle.module.css';

export const SectionTitle = ({ children, ...props }: {children: ReactNode}) => (
    <h1 {...props} className={styles.title}>{children}</h1>
);
